/**
 * 帐号冻结提示
 */
import Confirm from '../../lib/popup/confirm';
import lang from '../../lang';

export default {
	show: function() {
		UP.Global.DA.add({
            eventName: 'UplivePaymentFrozen',
            action: 'click'
        });

		Confirm.create({
			title: lang.template('账号冻结'),
			content: lang.template('账号被冻结，期间不能使用U钻送礼、发布弹幕等。如需解封，请联系VIP客服哦！'),
			confirmText: lang.template('VIP客服'),
			modalStyle: {
                marginLeft: (location.href.indexOf('/living') > -1 && UP.Global.siteLanguage == 'ar-EG') ? '55px' : '-55px'
            },
			onConfirm: () =>{
				this.goServiceRoom();
			}
		});
	},
	goServiceRoom: function(){
		let userInfo = UP.Global.getUser();
		let origin;
		let params;
		let url;

		if (location.host == 'h5.upliveapp.com') {
            origin = 'http://h5.upliveapp.com';
        } else {
        	origin = 'http://m.upliveapps.com';
        }

        params = {
        	uid: userInfo.uid,
        	country: userInfo.countryCode,
        	language: UP.Global.siteLanguage,
        	level: userInfo.grade
        }
		
		url = origin + '/upservice/custom.html?' + $.param(params); 

		UP.Global.openInNewTab(url);
	}	
}


// WEBPACK FOOTER //
// ./js/mall/recharge-result/frozen.js